/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'distance': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M15.255 0C16.768 0 18 1.108 18 2.625c0 .349-.102.912-.22 1.219L15.26 9l-2.518-5.156a4.17 4.17 0 01-.22-1.22c0-1.516 1.22-2.624 2.733-2.624zm.006 1.5c-.649 0-1.174.504-1.174 1.125s.525 1.125 1.174 1.125c.648 0 1.174-.504 1.174-1.125S15.909 1.5 15.26 1.5zM3.137 7.875c1.729 0 3.124 1.293 3.124 3 0 .392-.116.98-.25 1.324L3.13 18 .25 12.2A4.3 4.3 0 010 10.874c0-1.707 1.407-3 3.136-3zM13.5 7.2l.9 1.8h-3.6C9.818 9 9 9.409 9 10.35c0 .941.818 1.35 1.8 1.35h2.475c1.62 0 3.375 1.598 3.375 3.15 0 1.552-1.756 3.15-3.375 3.15H4.5l.9-1.8h6.75c1.2 0 2.7-.2 2.7-1.35 0-1.15-1.5-1.35-2.7-1.35h-2.025c-1.402 0-2.925-1.806-2.925-3.15 0-1.344 1.523-3.15 2.925-3.15H13.5zM3.13 9.562c-.756 0-1.369.588-1.369 1.313s.613 1.312 1.37 1.312c.756 0 1.37-.587 1.37-1.312 0-.725-.614-1.313-1.37-1.313z" _fill="#213F6B"/>'
  }
})
